import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_CONFIG } from '../../../utils/apiConfig';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer
} from 'recharts';
import './NewUsers.css';

const NewUsers = () => {
  const [recentCustomers, setRecentCustomers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRecentCustomers = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem('token');
        
        if (!token) {
          console.warn('No authentication token found');
          setRecentCustomers([]);
          return;
        }
        
        // Fetch all customers and get the recent ones
        const response = await axios.get(`${API_CONFIG.BASE_URL}/api/customers`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const customersData = response.data?.customers || response.data || [];
        const customers = Array.isArray(customersData) ? customersData : [];
        
        // Sort by creation date and take the latest 10
        const recent = customers
          .sort((a, b) => new Date(b.createdAt || b.created_date || 0) - new Date(a.createdAt || a.created_date || 0))
          .slice(0, 10)
          .map(customer => ({
            ...customer,
            id: customer.id || customer._id,
            name: customer.customerName || customer.name || customer.companyName || 'Unknown Customer',
            email: customer.email || customer.contactEmail || customer.customerEmail,
            createdDate: customer.createdAt ? new Date(customer.createdAt).toLocaleDateString() : 'N/A',
            createdBy: customer.createdBy || 'Unknown'
          }));

        setRecentCustomers(recent);
      } catch (err) {
        console.error('Error fetching recent customers:', err);
        // Set fallback data when API is unavailable
        setRecentCustomers([
          { name: 'Sample Customer 1', email: 'customer1@example.com', createdAt: new Date().toISOString() },
          { name: 'Sample Customer 2', email: 'customer2@example.com', createdAt: new Date().toISOString() },
          { name: 'Sample Customer 3', email: 'customer3@example.com', createdAt: new Date().toISOString() }
        ]);
      } finally {
        setLoading(false);
      }
    };

    fetchRecentCustomers();
  }, []);

  // Prepare data for chart (last 7 days)
  const prepareChartData = () => {
    const last7Days = [];
    for (let i = 6; i >= 0; i--) {
      const date = new Date();
      date.setDate(date.getDate() - i);
      const dateStr = date.toLocaleDateString();
      
      const count = recentCustomers.filter(customer => {
        const customerDate = customer.createdAt ? new Date(customer.createdAt).toLocaleDateString() : '';
        return customerDate === dateStr;
      }).length;
      
      last7Days.push({
        date: dateStr,
        count: count
      });
    }
    return last7Days;
  };

  return (
    <div className="newwuser-card">
      <h4>Recently Created Customers</h4>
      {loading ? (
        <div className="loading">Loading recent customers...</div>
      ) : (
        <>
          <ResponsiveContainer width="100%" height={200}>
            <BarChart data={prepareChartData()} margin={{ top: 20, right: 20, left: 0, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="date" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="count" fill="#8884d8" barSize={30} />
            </BarChart>
          </ResponsiveContainer>
          
   
        </>
      )}
    </div>
  );
};

export default NewUsers;
